import { Directive, Input, OnInit, TemplateRef } from '@angular/core';
import { MetadataTemplateManagerService } from '../services/metadata-template-manager.service';

@Directive({
  selector: '[plrMetadataTemplateRef]'
})
export class MetadataTemplateRefDirective implements OnInit {

  @Input('plrMetadataTemplateRef')
  name: string;

  constructor(private host: TemplateRef<any>,
    private metadataTemplateManager: MetadataTemplateManagerService) { }

  ngOnInit(): void {
    this.metadataTemplateManager.registerTemplate(this.name, this.host);
  }

}



// WEBPACK FOOTER //
// ./src/app/pillar/workspace/directives/metadata-template-ref.directive.ts